/**
 * type.js
 *
 * Defines string constants for Vuex mutation types.
 * Used to ensure consistency and prevent typos in mutation names across the application.
 */

export const SET_ACCOUNT_NAME = 'SET_ACCOUNT_NAME'; // Set the account name
export const SET_CONFIRMATION_DIALOG = 'SET_CONFIRMATION_DIALOG'; // Open confirmation dialog
export const CLOSE_CONFIRMATION_DIALOG = 'CLOSE_CONFIRMATION_DIALOG'; // Close confirmation dialog
export const SET_RESPONSE_DIALOG = 'SET_RESPONSE_DIALOG'; // Open response dialog
export const CLOSE_RESPONSE_DIALOG = 'CLOSE_RESPONSE_DIALOG'; // Close response dialog
export const SET_FILTER = 'SET_FILTER'; // Set filter criteria
export const SET_PAGINATION = 'SET_PAGINATION'; // Set pagination info
export const SET_SEARCH = 'SET_SEARCH'; // Set search query
export const SET_META_DATA = 'SET_META_DATA'; // Set meta data for tables
export const SET_SORTING = 'SET_SORTING'; // Set sorting order
export const SET_REGISTRANTS = 'SET_REGISTRANTS'; // Set registrant list
export const SET_TABLE_LOADING = 'SET_TABLE_LOADING'; // Set table loading state
export const CONFIRM_USER = 'CONFIRM_USER'; // Confirm a user
export const DECLINE_USER = 'DECLINE_USER'; // Decline a user
export const BLOCK_USER = 'BLOCK_USER'; // Block a user
export const UNBLOCK_USER = 'UNBLOCK_USER'; // Unblock a user
export const ADD_NOTE = 'ADD_NOTE'; // Add a note to a user
export const DELETE_USER = 'DELETE_USER'; // Delete a user

// Session/Invitation mutations
export const SET_SESSIONS = 'SET_SESSIONS'; // Set sessions list
export const SET_SESSIONS_LOADING = 'SET_SESSIONS_LOADING'; // Set sessions loading state
export const SET_SESSION_DETAILS = 'SET_SESSION_DETAILS'; // Set session details with users
export const SET_SESSION_DETAILS_LOADING = 'SET_SESSION_DETAILS_LOADING'; // Set session details loading state
export const SET_SESSION_COUNTS = 'SET_SESSION_COUNTS'; // Set session counts
export const SET_SESSION_COUNTS_LOADING = 'SET_SESSION_COUNTS_LOADING'; // Set session counts loading state
